import { useCallback } from "react";

export const useResize = () => {
  const forceResize = useCallback(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  return { forceResize };
};
